<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">

            <!-- Display Saved Templates -->
            <div class="col-12" v-if="!showTerms">
                <div class="top" style="height:60px;"></div>
                <h4 class="mb-6 font-semibold">Contract Templates</h4>

                <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl">
                    <small>
                        Easily create, edit and manage contract templates to suit your specific needs. Simply click the 'Create a new template' button to begin - from there, you can edit or remove default terms that have already been added, as well as add any of your own terms.
                        <br /><br />
                        When your template is finished, simply save it under a unique name of your choice, and you'll be able to use it for any future client or sub-contractor agreements.
                    </small>

                    <div style="display:flex;">
                        <div style="flex:1"></div>
                        <div class="btn btn-success" style="width: 250px; margin: 16px 0; font-weight: normal;" @click="createTemplate">
                            Create a new template
                            <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="#ffffff" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                        </div>
                    </div>


                    <div class="header" style="font-weight:bold; margin-left:16px;">My Templates</div>
                    <div class="contract-limit" v-if="!isFreeAccount()">{{ computeTemplateUsage() }}</div>
                    <div class="templates-container">

                        <div class="template-box" v-for="(template, index) in savedTemplates" :key="index">

                            <div class="template-card default" v-if="index==0"  @click="editTemplate(template.Id)">
                                <div class="template-type"> Default Contract</div>
                                <div class="template-title">Default Client and<br> Sub-Contract Template Or<br> Create Your Own Template</div>

                            </div>

                            <div class="template-card " v-else :class="template.Type === 1 ? 'client' : 'sub-contractor'">
                                <div class="template-type" v-if="template.Type == 1">
                                     
                                    <span style="flex:1;">Client Contract</span>

                                    <n-popover trigger="click">
                                        <template #trigger>
                                            <n-icon :size="16" :depth="2">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                            </n-icon>
                                        </template>
                                        <div class="text-base py-1">
                                            <n-button quaternary class="w-full  pr-[70px]" @click="editTemplate(`${template.Id}`)" style="color:black !important;">Edit</n-button>
                                            <n-divider class="!m-[1px]" dashed />

                                            <n-button quaternary class="w-full  pr-[55px]" @click="confirmDelete(`${template.Id}`,`${template.Tag}`,`${template.Type}`)" style="color:black !important;">Delete</n-button>
                                        </div>
                                    </n-popover>

                                </div>

                                <div class="template-type" v-else>
                                   
                                    <span style="flex:1;">Sub-Contractor Contract</span>

                                    <n-popover trigger="click">
                                        <template #trigger>
                                            <n-icon :size="16" :depth="2">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                            </n-icon>
                                        </template>
                                        <div class="text-base">
                                            <n-button quaternary class="w-full  pr-[70px]" @click="editTemplate(`${template.Id}`)" style="color:black !important;">Edit</n-button>
                                            <n-divider class="!m-[1px]" dashed />

                                            <n-button quaternary class="w-full  pr-[55px]" @click="confirmDelete(`${template.Id}`,`${template.Tag}`,`${template.Type}`)" style="color: black !important;">Delete</n-button>
                                        </div>
                                    </n-popover>

                                </div>

                                <div class="template-title">{{template.Tag}}</div>

                            </div>

                        </div>
                    </div>
                </div>



                <div class="terms-bg row" v-if="showTerms">
                    <div class="col-12" style="display:flex; margin-top:16px;">
                        <div style="flex:1;"></div>
                        <div class="closeBtn" @click="back">
                            <span class="material-icons" style="color:white;text-align:center;line-height:30px; margin:0;">close</span>
                        </div>
                    </div>

                    <div class="col-12 col-md-6" style="margin:4px 0;">
                        <label class="f12">Template Name</label>
                        <input v-model="Tag" class="form-control" placeholder="Name your template" />
                    </div>

                    <div class="col-12 col-md-6" style="margin:4px 0;">

                        <label class="f12" for="contractTypeSelect">Choose Contract Type</label>
                        <div style="display:flex;">
                            <div class="form-check" style="width: 50%; display:flex; align-self:center; align-items:center;">
                                <input class="form-check-input" type="radio" id="clientContract" value="1" v-model="ContractType" style="float:none; margin-left:0px; margin-top:0px;">
                                <label class="form-check-label" for="clientContract">
                                    Client Contract
                                </label>
                            </div>
                            <div class="form-check" style="width: 50%; display: flex; align-self: center; align-items: center; ">
                                <input class="form-check-input" type="radio" id="subcontractorContract" value="0" v-model="ContractType" style="float: none; margin-left: 0px; margin-top: 0px; ">
                                <label class="form-check-label" for="subcontractorContract">
                                    Subcontractor Contract
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">

                        <div class="title col-12 text-center">
                            Terms (uncheck if you don't want to add to your contract)
                        </div>


                        <div class="info">Please review the terms of your agreement. You may also choose to edit or delete any term to suit your unique needs</div>
                        <div style="text-align:right; font-size:10px;">
                            <span style="width:40px;"> Keep <br /> Clause</span>
                        </div>

                        <div class="col-12">
                            <div class="form-check terms-container" v-for="(item, idx) in Terms" :key="idx">
                                <label class="form-check-label editable" v-html="item" contenteditable="true"></label>
                                <input type="checkbox" :id="'Terms_'+idx" v-model="selectedTerms" :value="item" class="form-check-input" style="margin-right:8px;" />
                            </div>
                        </div>

                        <div class="col-12" style="text-align:right;">
                            <div class="btn btn-nagative" style="width: 130px; margin-right:16px;" @click="back">Cancel</div>
                            <div class="btn btn-positive" style="width: 130px; margin:0px 16px;" @click="addTerms">Add A New Term</div>
                            <div class="btn btn-positive" style="width: 170px;" @click="saveTemplate">Save Template</div>
                        </div>
                    </div>


                </div>


            </div>
            <CustomPopup :visible="showPopup"
                         :icon="popupIcon"
                         :iconSrc="popupIconSrc"
                         :iconColor="iconColor"
                         :title="popupTitle"
                         :content="content"
                         :cancelText="cancelText"
                         :confirmText="confirmText"
                         :confirmButtonType="confirmButtonType"
                         :confirmAction="currentConfirmAction"
                         @cancel="onCancel" />

            <FirstTimePopup 
                    :visible="showFirstTimePopup"
                    :title="firstTimePopupTitle"
                    :content="firstTimeContent" 
                    :confirmText="firstTimeConfirmText"
                    :confirmAction="firstTimeCurrentConfirmAction" 
                    @cancel="closeFirstTimePopup" />

        </div>
    </div>
</template>

<script>
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
    import CustomPopup from '../components/modals/CustomPopup.vue';
    import FirstTimePopup from '../components/modals/FirstTimePopup.vue';

    export default {
        components: {
            Sidebar, CustomPopup, FirstTimePopup
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
                UserId: "",
                sessionId: "",
                ClientTerms: [],
                SubcontractorTerms: [],
                ContractType: "client",
                Tag: "",
                selectedTerms: [], // For keeping track of checked terms
                savedTemplates: [], // To store saved templates
                showTerms: false,
                TermsId: '',

                OriginalClientTerms: [],
                OriginalSubcontractorTerms: [],


                //Custom Popup

                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,

                //First Time Popup
                showFirstTimePopup: false,
                firstTimePopupTitle: 'Customize Your Contracts',
                firstTimeContent: 'Use this section to create your own templated Client and/or Sub-contractor agreement. You may also customize any of our default templates to suite your business needs. If our default templates do not work for you, you may upload your own agreement to use.',
                firstTimeConfirmText: 'OK',
                firstTimeCurrentConfirmAction: null
            }
        },
        computed: {
            Terms() {
               
                return this.ContractType === 1 ? this.ClientTerms : this.SubcontractorTerms;
            }
        },
        mounted() {
            this.sessionId = this.$route.params.sessionid;

            this.UserId = this.$core.data.UserInfo.Id;

      
            this.getSubcontractorTerms();
            //this.getClientTerms();
             
            this.$core.reloadUserInfo();
           
        },
        methods: {

            isFreeAccount(){
                return this.$core.data.UserInfo.Metadata.TemplateLimit == -1;
            },
             
            computeTemplateUsage() {
                const quota = this.$core.data.UserInfo.Metadata.Subscription.TemplateQuota;
                const used = this.$core.data.UserInfo.Metadata.Subscription.TemplateUsed;
                
                return `${used}/${quota} Contract Templates Used`;
            },
            getCustomTermsList() {
               
                this.$http.request("get", "/api/app/customterm/readlist").then((res) => {

                    //console.log("getCustomTermsList",res);
                    if (res?.Type == 200) {
                        this.savedTemplates = [];

                        //add a default terms.
                        this.savedTemplates.push({ Id: '', Tag: "Default Client and Sub-Contract Template Or Create Your Own Template", CreatedDate: "", Type: 1, Terms: this.ClientTerms });

                        if(res.Data.length == 0){
                            this.$core.getTemplatePopup();
                            if(this.$core.data.ShowedTemplatePopup == true){
                                this.showFirstTimePopup = true;
                            }else{
                                this.showFirstTimePopup = false;
                            }
                            
                            //console.log("showFirstTimePopup",this.showFirstTimePopup);
                            this.$core.setTemplatePopup(false);
                            //this.showFirstTimePopup = true;
                        }

                        this.savedTemplates.push(...res.Data);

                        //console.log(this.savedTemplates);
                    }
                });

            },
             
            createTemplate() {
                this.$core.data.SelectedCustomTerms = null;

                this.$router.push('/ContractTemplateDetail');
                 
            },
            back() {
                this.showTerms = false;
            },
            addTerms() {

                if (this.ContractType === 1) {
                    this.ClientTerms.push("");                    
                } else {
                    this.SubcontractorTerms.push("");
                }
                if (this.TermsId.length != 0)
                    this.selectedTerms.push("");

                 
            },

            saveTemplate() {

                if (this.Tag.length === 0 || this.Tag === 'Default Contract Template') {
                    this.$ui.alert(this, "Please enter a name for your template", "", null);

                    return;
                }

                var elts = document.getElementsByClassName("editable");
                var newTerms = [];
                for (var i = 0; i < elts.length; i++) {
                    if (document.getElementById("Terms_" + i).checked) {
                        newTerms.push(elts[i].innerHTML);
                    }
                }

                let _this = this;
                if (this.TermsId.length === 0) {
                    const data = {
                        Tag: this.Tag,
                        Type: this.ContractType ,
                        Terms: newTerms,
                        UserId: this.UserId
                    };
                    //console.log("template", data);

                    this.$http.request("post", "/api/app/customterm/create", data).then((res) => {
                        //console.log("Add CustomTerms", _data);

                        if (res?.Type == 200) {
                            _this.getCustomTermsList();

                        }
                    });
                } else {

                    const data = {
                        Id: this.TermsId,
                        Tag: this.Tag,
                        Type: this.ContractType  ,
                        Terms: newTerms,
                        UserId: this.UserId
                    };
                    //console.log("eidt template", data);

                    this.$http.request("put", "/api/app/customterm/update", data).then((res) => {
                        //console.log("Edit CustomTerms", _data);

                        if (res?.Type == 200) {
                            _this.getCustomTermsList();

                        }
                    });

                }
                
                this.$fire({
                    title: "Success",
                    html: this.$ui.buildMsg("Success", "Contract Template Saved!"),
                    showConfirmButton: true,
                    timer: 2000
                }).then(r => { });
                this.Tag = ''; // Clear the tag input after saving
                this.selectedTerms = []; // Clear selected terms after saving

                this.back();
            },

            confirmDelete(id, name,type) {
                let _this = this;
 
                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/InfoIcon.png'); // Replace with your image path
                this.popupTitle = "Delete Contract Template";
                this.content = "Are you sure you want to delete this client contract template for \"" + name + "\"?";
                if(type == 0)
                    this.content = "Are you sure you want to delete this sub-contractor contract template for \"" + name + "\"?";
                this.cancelText = "Cancel";
                this.confirmText = 'Delete';
                this.confirmButtonType = 'success';
                this.currentConfirmAction = () => {
                    var data = [id];

                    this.$http.request("delete", `/api/app/customterm/delete`, data).then((res) => {

                        if (res?.Type == 200) {
                            _this.getCustomTermsList();

                            _this.$core.reloadUserInfo();
                            this.showPopup = true;


                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null; // Replace with your image path
                            this.popupTitle = "Contract Template Deleted!";
                            this.content = "";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;
                           
                        }
                    });
                };

                
            },
            editTemplate(id) {

                if (id === '') {
                    this.createTemplate();
                    return;
                }
                const template = this.savedTemplates.find(m => m.Id == id);

                this.$core.data.SelectedCustomTerms = template;

                this.$router.push('/ContractTemplateDetail');

                /**
                //console.log("template", template);
                this.Tag = template.Tag;
                this.ContractType = template.Type ;

                this.TermsId = id;

                if (this.ContractType === 1) {
                    this.ClientTerms = [...template.Terms];
                } else {
                    this.SubcontractorTerms = [...template.Terms];
                }

                this.selectedTerms = [...template.Terms];

                this.showTerms = true;

                 */
               
               
            },
            getSubcontractorTerms() {
                this.$http.request("get","/api/app/term/readlist?type=0").then((res) => {
                    if (res?.Type == 200) {
                        res.Data.forEach(item => {
                            this.SubcontractorTerms.push(item.Text);
                            
                            this.OriginalSubcontractorTerms.push(item.Text);
                        });
                        this.getClientTerms();
                    }
                });
            },

            getClientTerms() {
                this.$http.request("get", "/api/app/term/readlist?type=1").then((res) => {
                    if (res?.Type == 200) {
                        res.Data.forEach(item => {
                          
                            this.ClientTerms.push(item.Text);

                            this.OriginalClientTerms.push(item.Text);
                     
                        });
                        this.getCustomTermsList();
                    }
                });
            },
            onCancel() {
                this.showPopup = false;
                this.currentConfirmAction = null;
            },
            closeFirstTimePopup() {
                this.showFirstTimePopup = false;
            }
        }
    };
</script>

<style scoped>
    /* Custom styling */
    .container-fix {
        border-radius: 8px;
        min-height:100vh;
    }

    .terms-bg{background-color:white; border-radius:15px; margin-top:40px;}
    .content {
        display: flex;
        flex-wrap: wrap;
    }
    /* Container holding the templates */
    .templates-container {
        display: flex;
        width: 100%; /* Responsive grid */
        gap: 16px;
        padding: 16px;
        border: 1px solid gray;
        border-radius: 5px;
        margin: 16px 0px;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch; /* Ensures all cards stretch to the same height */
    }

    /* Individual card styles */
    .template-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 8px;
        padding: 8px;       
        min-width: 260px;
        min-height: 150px; /* Ensures a minimum height */
        color: black;
        font-weight: bold;
        cursor: pointer;
        background-size: cover;
    }

       
    /* Title of the template */
    .template-title {
        word-break: break-all;
        max-width: 244px;
        font-size: 0.9em;
        display: flex;
        margin-top: 24px;
        margin-bottom: 8px;
        word-wrap: break-word; 
        overflow-wrap: break-word; 
    }

    /* Contract type tag */
    .template-type {
        font-size: 0.7em;       
        border-radius: 4px;
        display: flex;
        align-items:center;
    }

    /* Card colors based on contract type */
    .template-card.client {
        background-image: url('../assets/images/CLIENT_CONTRACT.png');
    }

    .template-card.sub-contractor {
        background-image: url('../assets/images/SUBCONTRACTOR_CONTRACT.png');
    }

    .template-card.default {
        background-image: url('../assets/images/DEFAULT_CONTRACT.png');
    }

        .template-card.default:hover {
            opacity: 0.5;
        }
    .template-card.client:hover {
        opacity: 0.5;
    }
    .template-card.sub-contractor:hover {
        opacity: 0.5;
    }

    /* Menu icon (three dots) */
    .template-menu {
        position: absolute;
        top: 8px;
        right: 8px;
        cursor: pointer;
    }
     
    .contract-box {
        min-height: 300px;
        background-color: aliceblue;
    }
    .contract-box .header{
        color:white; 
        padding: 4px 16px;
    }
    .title{font-weight:bold; font-size:20px !important; margin: 16px 0; padding:0px;}

    .closeBtn{background-color:black; color:white; border-radius:50%; width:30px; height:30px; cursor:pointer; text-align:center;}
    .terms-container {
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: #fdeddc;
        padding: 4px;
        margin: 8px 0;
    }

    .form-check .form-check-input {
        float: right;
        margin-left: -1.5em;
    }

    .form-check-label {
        padding: 4px;
         
        margin-right: 20px !important;
        width: calc(100% - 40px);
    }

    .form-check {
        padding-left: .5em;
        padding-right: 0px !important;
        width: 100%;
    }

    .info {
        font-size: 12px;
        color: black;
        text-align: center;
    }


    .title {
        font-size: 14px;
    }

    .form-check-label.editable {
        cursor: text;
    }

    .mt-3 {
        margin-top: 1rem;
    }

    .mt-4 {
        margin-top: 1.5rem;
    }

    .contract-limit{font-size: 12px; color:black; text-align: right;}

    @media (max-width: 768px) {
        /* Mobile version */
        .templates-container{justify-content: center;}
        .template-card {width: 100%;}
        .template-box {width: 100%; max-width: 400px;}
    }
</style>
